





















































import { defineComponent } from '@vue/composition-api'
import { onMounted } from '@nuxtjs/composition-api'
import { defineProps } from '@/helpers/defineProps'
import { BlockListArchiveItemsProps } from '@/contracts/BlockListArchiveItems'
import BlockArchiveItem from '@/components/BlockArchiveItem.vue'
import BlockText from '@/components/BlockText.vue'

export default defineComponent({
  name: 'BlockListArchiveItems',
  components: { BlockText, BlockArchiveItem },
  props: defineProps<BlockListArchiveItemsProps>({
    title: {
      default: '',
    },
    list: {
      default: () => [],
    },
    isInnerBanner: {
      default: false,
    },
    staticList: {
      default: true,
    },
  }),
  setup(props) {
    // Собираем Set с id основных элементов (из props.list)
    const mainIds = new Set<string>(props.list.map((item) => item.id))

    // Функция для удаления дубликатов в массиве linkedDocuments,
    // исключая те, которые уже есть в основном массиве.
    const dedupedLinkedDocuments = (documents: any[]) => {
      return dedupedLinkedDocumentsHelper(documents, mainIds)
    }

    // Вынесем реализацию в отдельную функцию для удобства (см. функцию выше)
    function dedupedLinkedDocumentsHelper(
      documents: any[],
      mainIds: Set<string>
    ): any[] {
      if (!Array.isArray(documents)) return []
      const uniqueMap = new Map<string, any>()
      documents.forEach((doc) => {
        if (doc && doc.id && !uniqueMap.has(doc.id) && !mainIds.has(doc.id)) {
          uniqueMap.set(doc.id, doc)
        }
      })
      return Array.from(uniqueMap.values())
    }

    return {
      dedupedLinkedDocuments,
    }
  },
})
